module.exports = __webpack_public_path__ + "img/wsf.9eef6c1d.png";